import type { NextPage } from 'next'
import Head from 'next/head'

import { PrivacyPolicySlice } from '@/slices/Help'
import { Layout } from '@/slices/Layout'
import { getLayoutProps } from '@/slices/Layout/global/layout'

const PrivacyPage: NextPage = () => {
  const layoutProps = getLayoutProps()

  return (
    <>
      <Head>
        <title>Privacy Policy | Pixie World</title>
        <meta
          name="description"
          content="Learn about how PixieWorld protects your privacy and handles your data when you use our personalized storybook services."
        />
      </Head>

      <Layout {...layoutProps}>
        <PrivacyPolicySlice />
      </Layout>
    </>
  )
}

export default PrivacyPage